import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { validateBasis } from '@angular/flex-layout';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/core/service/common-service/common.service';

@Component({
  selector: 'app-visit-report',
  templateUrl: './visit-report.component.html',
  styleUrls: ['./visit-report.component.css']
})
export class VisitReportComponent implements OnInit {

  visitReportForm=this.fb.group({
    Name:["",Validators.required],
    Date:['',Validators.required],
     place:['',Validators.required],
    RegNo:['',Validators.required],
    EicherMake:['',Validators.required],
    OtherMake:['0',Validators.required],
    Total:['',Validators.required],
    EarlierProvidedOffer:['',Validators.required],
    Remark:['',Validators.required],

    Remark4:['',Validators.required],
    DisengagementReason:['',Validators.required],
    AnyProposalMade:['',Validators.required]  ,
    AnyRequirementForNewVehicle:['',Validators.required] ,
    interestedInSoftOffering:['',Validators.required],
    CustomerVisit:['',Validators.required],
    photoName:['',Validators.required],
    Photo:['',Validators.required]
   });

  customerData: any;
  userInfo:any
  formData = new FormData();
  countryCode: string;
  attachmentName: string;
  date:String;
  spinner:boolean;

  constructor(private fb:FormBuilder, private commonService: CommonService,private toastr: ToastrService,
   private dialogRef:MatDialogRef<VisitReportComponent>, private datePipe: DatePipe) {

    }

  ngOnInit() {
    this.autoFillVisitReport();
    this.customerData = JSON.parse(localStorage.getItem("customerData"));
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  }

  autoFillVisitReport(){
    this.spinner =true;
    this.commonService.getAutoFillVisitReport().subscribe(res=>{
      if (res["responseCode"] == 0) {
        this.visitReportForm.patchValue({
          Name:res['responseData']['customerName'],
          Date:res['responseData']['visitingDate'],
          place:res['responseData']['address'],
          RegNo:res['responseData']['registrationNo'],
          DisengagementReason:res['responseData']['disengageReason'],
          EarlierProvidedOffer:res['responseData']['proposal'],
          EicherMake:res['responseData']['fleetCount'],
          Remark:res['responseData']['remarks']
        })
        this.countTotal();
        this.spinner =false;
      }
      else{
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  countTotal() {
    let total;
    total=Number(this.visitReportForm.get('EicherMake').value) + Number(this.visitReportForm.get('OtherMake').value);
    total=total.toString();
    this.visitReportForm.get('Total').patchValue(total);
  }

  onFileChange(event){
    this.formData = new FormData();
    let file: File = event.target.files[0];
    this.visitReportForm.get('photoName').setValue(file.name);
    let filePath = event.currentTarget.value.split("\\")[2];
    this.formData.append('file', file, filePath);
  }

  deleteImage(){
    this.visitReportForm.controls['photoName'].reset();
  }

  onclose(){
    this.dialogRef.close();
 }

  onSubmit() {
    if(this.visitReportForm.get('AnyProposalMade').valid &&
      this.visitReportForm.get('AnyRequirementForNewVehicle').valid &&
      this.visitReportForm.get('interestedInSoftOffering').valid &&
      this.visitReportForm.get('Remark4').valid &&
      this.visitReportForm.get('CustomerVisit').valid &&
      this.visitReportForm.get('photoName').valid) {

      let totalFleetCount;
      let newProposal;
      let newVehicle;
      let softOff;
      let remark;
      let workshopVisit;

      this.spinner=true;
      totalFleetCount=this.visitReportForm.get('Total').value;
      newProposal=this.visitReportForm.get('AnyProposalMade').value;
      newVehicle=this.visitReportForm.get('AnyRequirementForNewVehicle').value;
      softOff=this.visitReportForm.get('interestedInSoftOffering').value
      remark=this.visitReportForm.get('Remark4').value;
      workshopVisit=this.visitReportForm.get('CustomerVisit').value;

      let file = this.formData;


      this.commonService.saveVisitReportForm(totalFleetCount, newProposal, newVehicle, softOff, remark, workshopVisit, this.visitReportForm.get('photoName').value, file).subscribe(res => {
        if (res["responseCode"] == 0) {
          this.toastr.info(res['message'], "Success");
          this.spinner = false;
          this.dialogRef.close("false");
        }
        else{
          this.toastr.error(res['message'], "Error");
          this.spinner = false;
          this.dialogRef.close();
        }
      }, error => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
        this.dialogRef.close();
      });
    } else {
        this.toastr.error("Please fill Complete Form");
    }
  }

  /**
   * If touched field is empty, this function will show error
   * @param control
   */
  hasError(control: any): boolean {
    return (
      control &&
      (control.touched || control.dirty) &&
      !control.valid
    );
  }
}

export function openvisitReportDialog(dialog:MatDialog) {

  const config=new MatDialogConfig();
  config.disableClose=true;
  config.autoFocus=true;
  config.width='850px';
  config.height='550px';

  const dialogRef=dialog.open(VisitReportComponent,config);
  return dialogRef.afterClosed();
}
